/* eslint-disable */
import pt from 'vuetify/lib/locale/pt';

export default {
  ...pt,
  // NOMES IDIOMAS
  'campo vazio': '',
  idioma: 'Idioma',
  // GERAL
  meusDados: 'Meus dados',
  sair: 'Sair',
  pesquisar: 'Pesquisar',
  kanban: 'Kanban',
  todosClientes: 'Todas as empresas',
  null: 'N/I',
  selecionados: 'Selecionados',
  recusar: 'Recusar',
  aceitar: 'Aceitar',
  // NOVAS ATUALIZAÇÕES
  novasAtualizacoes: 'NOVO!',
  // FILTROS
  pesquisarBy: 'Pesquisar processos pelo código ou referência',
  filtros: 'Filtros',
  download: 'Download',
  periodo: 'Período',
  tipoData: 'Tipo de data:',
  mostrarEncerrados: 'Mostrar processos encerrados',
  encerrado: 'Encerrado',
  Abertura: 'Abertura',
  ETD: 'ETD',
  ETA: 'ETA',
  etd: 'ETD',
  eta: 'ETA',
  Embarque: 'Embarque',
  Chegada: 'Chegada',
  Originais: 'Originais',
  'Registro DI': 'Registro DI',
  removerFiltros: 'Remover filtros',
  filtrar: 'Filtrar',
  ate: ' até ',
  warningFiltro: 'Selecione um período válido e um tipo de busca.',
  // MENU
  dashboard: 'Dashboard',
  tituloTooltipDashboard: 'Visualize os dados estatísticos sobre \no desempenho dos processos de importação.',
  demandas: 'Demandas',
  abrirProcessos: 'Abrir processos',
  novosProcessos: 'Novos processos',
  tituloTooltipNovosProcessos: 'Inicie um novo processo e aguarde o andamento deste para as estapas de \nimportação. Edite os processos clicando duas vezes em cima do campo desejado.',
  inicieUmNovoProcesso: 'Inicie um novo processo e aguarde o andamento deste para as etapas de importação.',
  followUp: 'Follow-Up',
  inventario: 'Inventário',
  tituloTooltipEstoque:
    'Possui o propósito de manter os níveis ideais de estoque, \nde acordo com os objetivos e demandas da empresa.',
  armazem: 'Armazém',
  financeiro: 'Financeiro',
  relatorios: 'Relatórios',
  relatorio: 'Relatório',
  tituloTooltipRelatorios:
    'Agende o envio de relatórios para o e-mail sobre seus processo \ne fique por dentro das atualizaçôes que ocorrem.',
  nomeRelatorio: 'Nome Relatório',
  documentos: 'Documentos',
  base: 'Base',
  usuarios: 'Usuários',
  tituloTooltipUsuarios: 'Cadastre usuários para poder compartilhar dados',
  selecione: 'Selecione',
  selecioneTipo: 'Selecione um tipo de usuário',
  selecioneDias: 'Selecione quantos dias desejar',
  claro: 'Claro',
  escuro: 'Escuro',
  direitosReservados: 'Todos os direitos reservados',
  versao: 'Versão',
  termosCondicoes: 'Termos e Condições',
  politicasPrivacidade: 'Políticas de privacidade',
  // ROLES
  ADMINISTRADOR: 'ADMINISTRADOR',
  ANALISTA: 'ANALISTA',
  CLIENTE: 'CLIENTE',
  CLIENTE_GESTOR: 'CLIENTE GESTOR',
  'CLIENTE GESTOR': 'CLIENTE GESTOR',
  CLIENTE_CONSULTOR: 'CLIENTE CONSULTOR',
  'CLIENTE CONSULTOR': 'CLIENTE CONSULTOR',
  // MODAL EXPORTAR EM EXCEL
  tituloModalExportar: 'Exportar em planilha Excel',
  planilhaBaixada: 'Planilha baixada com sucesso',
  descricaoModalExportar: 'Seleciona as colunas que você deseja exibir.',
  disponiveis: 'Disponíveis',
  selecionadas: 'Selecionadas',
  selecionarTodos: 'Selecionar todos',
  removerTodos: 'Remover todos',
  gerarArquivo: 'Salvar arquivo',
  Referência: 'Referência',
  Processo: 'Processo',
  'Status do Embarque': 'Status do Embarque',
  'Unidade de Negócio': 'Unidade de Negócio',
  'Unidade de Medida': 'Unidade de Medida',
  Quantidade: 'Quantidade',
  Exportador: 'Exportador',
  Transportadora: 'Transportadora',
  Produto: 'Produto',
  'Conhecimento de Embarque': 'Conhecimento de Embarque',
  'Número DI': 'Número DI',
  'Canal DI': 'Canal DI',
  Desembaraço: 'Desembaraço',
  Faturamento: 'Faturamento',
  'Nº NF Entrada': 'Nº NF Entrada',
  Containers: 'Containers',
  tituloTooltipContainers:
    'Essencial para garantir o sucesso das operações de transporte marítimo de cargas, \nproporcionando eficiência, segurança e qualidade aos processos de importação.',
  Container: 'Container',
  'Emissão NF Entrada': 'Emissão NF Entrada',
  'Fechamento Operacional': 'Fechamento Operacional',
  'Exec. Carregamento': 'Exec. Carregamento',
  'Licenças de Importação': 'Licenças de Importação',
  'Armador/Agente de carga': 'Armador/Agente de carga',
  // COLUNAS KANBAN
  tituloTooltipKanban: 'Clique no cartão para mais detalhes do seu processo.',
  tooltipPreEmbarque: 'Data da abertura do processo até a data do embarque',
  tooltipTransito: 'Data do embarque até a chegada do navio no porto',
  tooltipDesembaraco: 'Data da chegada da carga no porto até o desembaraço da DI',
  tooltipCarregamento: 'Data do desembaraço da DI até a conclusão do carregamento',
  tooltipFaturamento: 'Data da conclusão do carregamento até o fechamento operacional',
  preEmbarque: 'Pré-Embarque',
  transito: 'Em Trânsito',
  carregamento: 'Carregamento',
  Carregamento: 'Carregamento',
  carregamentoFaturamento: 'Carregamento/Faturamento',
  carrFaturamento: 'Carr./Faturamento',
  solicitacao: 'Solicitação',
  previsaoNaoInformada: 'Prev. emb não informada',
  dataCarregamento: 'Data carr.',
  dataDoFaturamento: 'Data faturamento',
  dataFat: 'Data fat.',
  restam: 'Restam',
  dias: 'dias',
  atrasado: 'Atrasado',
  emDesembaraco: 'Em desembaraço: ',
  emCarregamento: 'Em carregamento: ',
  emFaturamento: 'Em faturamento: ',
  emFechamento: 'Em fechamento: ',
  diaChegada: 'Dia previsto da chegada',
  registro: 'Registro',
  nenhumItemFoi: 'Nenhum item foi',
  encontradoNaEtapa: 'encontrado na etapa',
  deFaturamento: 'de Faturamento',
  deCarregamento: 'de Carregamento',
  deDesembaraco: 'de Desembaraço',
  deTransito: 'de Trânsito',
  deEmbarque: 'de Pré-embarque',
  Fechamento: 'Fechamento',
  'Em Trânsito': 'Em Trânsito',
  'Em trânsito': 'Em Trânsito',
  'Pré-Embarque': 'Pré-Embarque',
  // MODAL PROCESSO
  numeroContrato: 'Número do contrato',
  taxaCambial: 'Taxa Cambial',
  dataPagamento: 'Data pagamento',
  valorReal: 'Valor em real',
  variacaoCambial: 'Variação cambial',
  cambio: 'Câmbio',
  tituloTooltipCambio: 'Acompanhe as modalidades de pagamentos, vencimentos e tipos de negociações.',
  informacoes: 'Informações',
  invoices: 'Invoices',
  contaCorrente: 'Conta corrente',
  maritima: 'Maritima',
  rodoviaria: 'Rodoviária',
  aerea: 'Aérea',
  embarque: 'Embarque',
  informacoesGerais: 'Informações Gerais',
  tipoProcesso: 'Tipo do processo',
  unidadeNegocio: 'Unidade do negócio',
  referenciaInterna: 'Referência interna',
  referenciaTrust: 'Referência Trust',
  referenciaCliente: 'Referência Cliente',
  'Referência Cliente': 'Referência Cliente',
  'Referência Trust': 'Referência Trust',
  cliente: 'Cliente',
  exportador: 'Exportador',
  produto: 'Produto',
  invoice: 'Invoice',
  cidadeEmbarque: 'Cidade de embarque',
  cidadeDestino: 'Cidade de destino',
  'CONTA E ORDEM': 'CONTA E ORDEM',
  'CONTA E ORDEM DE TERCEIROS': 'CONTA E ORDEM',
  'CONTA PRÓPRIA': 'CONTA PRÓPRIA',
  'CONTA PROPRIA': 'CONTA PRÓPRIA',
  'IMPORTAÇÃO POR ENCOMENDA': 'IMPORTAÇÃO POR ENCOMENDA',
  transporteLogistica: 'Transporte e Logística',
  statusEmbarque: 'Status embarque',
  modal: 'Modal',
  tipoCarga: 'Tipo de carga',
  incoterm: 'INCOTERM',
  incoterms: 'Incoterms',
  conhecimento: 'Conhecimento',
  navioVeiculo: 'Navio/Veículo',
  containers: 'Containers',
  container: 'Container',
  containerConsolidado: 'Container consolidado',
  devolucaoContainer: 'Devolução container',
  pesoBrutoKG: 'Peso Bruto(KG)',
  pesoLiquidoKG: 'Peso Liquido(KG)',
  URFEntrada: 'URF Entrada/Chegada',
  freeTime: 'Free Time',
  freetime: 'Free Time',
  freteCollect: 'Frete collect',
  fretePrepaid: 'Frete prepaid',
  valorTotalFrete: 'Valor total frete',
  moedaFrete: 'Moeda Frete',
  embalagemFrete: 'Embalagem',
  quantidadeEmbalagem: 'Qtd. Embalagem',
  datasPrevistas: 'Datas previstas',
  previsaoEmbarque: 'Prev. embarque',
  previsaoChegada: 'Previsão de chegada',
  datasConfirmadas: 'Datas confirmadas',
  dataEmbarque: 'Data de embarque',
  dataChegada: 'Data de chegada',
  datasLiberacoes: 'Datas e liberações',
  dataLiberacaoSiscarga: 'Data de liberação Siscarga',
  dataLiberacaoMapa: 'Data de liberação mapa',
  liberacaoMinisterioAgricultadoPecuaria: 'Data de liberação MAPA',
  ultimaMovimentacao: 'Última movimentação',
  presencaCarga: 'Presença de carga',
  licencasImportação: 'Liçenças de importação',
  tituloTooltipLI: 'Acompanhe as licenças necessárias para a importação, visando a \nregurlamentação do comércio internacional e proteção da economia nacional.',
  numLi: 'Nº da LI',
  orgaoAnuente: 'Órgão anuente',
  dataRegistro: 'Data de registro',
  dataStatus: 'Data de status',
  dataValidade: 'Data de validade',
  statusLicenca: 'Status da licença',
  'Status L.I': 'Status da licença',
  declaracaoImportacao: 'Declaração de importação',
  numeroRegistro: 'Número do registro',
  dataDesembaraco: 'Data do desembaraço',
  canalParametrizacao: 'Canal de parametrização',
  parametrizacao: 'Parametrização',
  atualizacoes: 'Atualizações',
  ultimaAtualizacao: 'Última atualização',
  dataNaoInformada: 'Data não informada',
  baixarTodos: 'Baixar Todos',
  solicitacaoNumerario: 'Solicitação de numerário',
  descricao: 'Descrição',
  dataSolicitacao: 'Data da solicitação',
  'Data da solicitação': 'Data da solicitação',
  acessar: 'Acessar',
  Acessar: 'Acessar',
  fechamentoProcesso: 'Fechamento de processo',
  visualizar: 'Visualizar',
  Visualizar: 'Visualizar',
  processo: 'Processo',
  data: 'Data',
  formacaoValorAduaneiro: 'Formação do valor aduaneiro',
  valorAduaneiroEstimado: 'Valor aduaneiro estimado',
  composicao: 'Composição',
  moeda: 'Moeda',
  Moeda: 'Moeda',
  valorNegociado: 'Valor negociado',
  valorBRL: 'Valor BRL',
  impostos: 'Impostos',
  despesasNacionalizacao: 'Despesas de nacionalização',
  icmsIpiTransferencia: 'ICMS/IPI Transferência',
  referencia: 'Referência',
  codigoProcesso: 'Código processo',
  'II - IMPOSTO DE IMPORTAÇAO': 'IMPOSTO DE IMPORTAÇAO',
  naoInformado: 'Não informado',
  semAtualizacoes: 'Sem atualizações',
  as: 'ás',
  semDocumentos: 'Sem documentos disponíveis',
  solicitar: 'Solicitar',
  documento: 'Documento',
  dataEmissao: 'Data de emissão',
  numerario: 'Numerário',
  total: 'Total',
  Total: 'Total',
  nenhumaInformacao: 'Nenhuma informação até o momento',
  notasComplementares: 'Notas complementares',
  notasFiscalEletronica: 'Nota fiscal eletrônica',
  valorNota: 'Valor nota fiscal',
  numeroNota: 'Número da nota',
  codigoDocumento: 'Código do documento',
  totalBruto: 'Total bruto',
  totalLiquido: 'Total liquido',
  despesa: 'Despesa',
  valorBruto: 'Valor bruto',
  valorLiquido: 'Valor liquido',
  meioUtilizado: 'Meio de tansporte utilizado',
  lclFcl: 'LCL (Consolidado/Carga solta), FCL (Em container)',
  tipoBL: 'Número do B/L (Conhecimento de embarque)',
  recintoDesembaraco: 'Recinto aduaneiro de desembaraço',
  unidadeReceitaFederal: 'Unidade da receita federal referente ao porto de entrada',
  VERDE: 'VERDE',
  AMARELO: 'AMARELO',
  VERMELHO: 'VERMELHO',
  CINZA: 'CINZA',
  invoicesProcesso: 'Invoices do processo',
  numeroInvoice: 'Número da invoice',
  produtosInvoice: 'Produtos da invoice',
  item: 'Item',
  Item: 'Item',
  fabricante: 'Fabricante',
  Fabricante: 'Fabricante',
  NCM: 'NCM',
  quantidade: 'Quantidade',
  condicaoPagamento: 'Condição de pagamento',
  'Condição de pagamento': 'Condição de pagamento',
  unidadeMedida: 'Unidade de medida',
  'Unidade de medida': 'Unidade de medida',
  valorUnitario: 'Valor Unitário',
  'Valor Unitário': 'Valor Unitário',
  totalCredito: 'Total crédito',
  totalDebito: 'Total débito',
  diferenca: 'Diferença',
  origem: 'Origem',
  Origem: 'Origem',
  evento: 'Evento',
  Evento: 'Evento',
  credito: 'Crédito',
  Crédito: 'Crédito',
  debito: 'Débito',
  Débito: 'Débito',
  vencimento: 'Vencimento',
  Vencimento: 'Vencimento',
  complemento: 'Complemento',
  Complemento: 'Complemento',
  mapa: 'Mapa',
  notaFiscalEntrada: 'Nota fiscal entrada',
  ENCOMENDA: 'ENCOMENDA',
  PROPRIO: 'PRÓPRIO',
  PRÓPRIO: 'PRÓPRIO',
  'ENCOMENDA PADRAO': 'ENCOMENDA PADRÃO',
  'ENCOMENDA PADRÃO': 'ENCOMENDA PADRÃO',
  'ENCOMENDA ESPECIAL': 'ENCOMENDA ESPECIAL',
  'Nº da LI': 'N° da LI',
  'Órgão anuente': 'Órgão anuente',
  'Data de registro': 'Data de registro',
  'Data de status': 'Data de status',
  'Data de validade': 'Data de validade',
  'Status da licença': 'Status da licença',
  'SEM PARAMETRO': 'SEM PARAMETRO',
  // MAPA
  maritimo: 'Marítimo',
  rodoviario: 'Rodoviário',
  todos: 'Todos',
  abrirProcesso: 'Abrir processo',
  abrirProcessoNovaAba: 'Abrir processo em um nova aba',
  embarcacao: 'Embarcação',
  veiculos: 'Veículos',
  portos: 'Portos',
  armazemTaglog: 'Armazém TRUST',
  agrupamentos: 'Agrupamentos',
  trajetoPrevisto: 'Trajeto previsto',
  trajetoPercorrido: 'Trajeto percorrido',
  cotacao: 'Cotação',
  dolar: 'Dólar',
  euro: 'Euro',
  especialistaComex: 'Especialista em COMEX',
  email: 'E-mail',
  celularWhatsapp: 'WhatsApp',
  destino: 'Destino',
  navio: 'Navio',
  Navio: 'Navio',
  visualizarProcesso: 'Visualizar processo',
  porto: 'Porto',
  numeroPassagens: 'Número de passagens',
  CNPJ: 'CNPJ',
  localizacao: 'Localização',
  naviosAgrupados: 'Navios agrupados',
  portosAgrupados: 'Portos agrupados',
  clientesAgrupados: 'Clientes agrupados',
  viagensAgrupados: 'Viagens agrupadas',
  CTE: 'CTe nº',
  viagem: 'Viagem',
  atualizadoEm: 'Atualizado em:',
  por: 'por',
  status: 'Status',
  remetente: 'Remetente',
  destinatario: 'Destinatário',
  destinatarios: 'Destinatários',
  informacaodeCarga: 'Informação de carga',
  valorCarga: 'Valor carga',
  valorCargaAverbada: 'Valor carga averbada',
  valorPrestado: 'valorPrestado',
  valorRecebido: 'valorRecebido',
  // MODAL SELECIONAR CLIENTES
  selecionarClientes: 'Selecionar empresas',
  // ABERTURA DE PROCESSO
  aberturaProcesso: 'Abertura de processo',
  solicitarCancelamento: 'Solicitar cancelamento de processo',
  solicitarAlteracao: 'Solicitar alteração',
  alteracoesEncaminhadas: 'Suas alterações foram salvas e serão encaminhadas para os nossos especialistas analisarem',
  jaPossuiAlteracao: 'Este processo já possui uma solicitação de alteração',
  aguardandoAprovaoAlteracao: 'Aguardando aprovação de alteração',
  solicitacaoAlteracaoPendente: 'Você possui uma solicitação de alteração pendente neste processo',
  alteracoesFeitas: 'Alterações feitas pelo cliente',
  aceitarSolicitacaoPendente: 'Aceitar alterações no processo',
  desejaAceitarAsAlteracoes: 'Você deseja aceitar as alterações?',
  casoAceite: 'Se você confirmar, os dados deste processo serão alterados',
  aguardandoCancelamento: 'Aguardando cancelamento do processo',
  seVoceConfirmar: 'Se você confirmar essa solicitação, ela irá sobrescrever a solicitação atualmente em espera',
  emCancelamento: 'Em cancelamento',
  processoAtualizado: 'Sua solicitação de processo foi atualizada',
  suaSolicitacaoDeCancelamento:
    'Sua solicitação de cancelamento foi encaminhada para nossos especialistas',
  exibirColunas: 'Exibir colunas',
  'Tipo Importação': 'Tipo Importação',
  Finalidade: 'Finalidade',
  modelosProntos: 'Modelos prontos',
  Empresa: 'Empresa',
  'Solicitado em': 'Solicitado em',
  solicitadoPor: 'Solicitado por',
  responsavel: 'Responsável',
  Ações: 'Ações',
  responsaveisNaoVinculados: 'Não há responsáveis vinculados a sua empresa',
  registrosPorPagina: 'Registros por página',
  registros: 'Registros',
  resultados: 'Resultados',
  editar: 'Editar',
  remover: 'Remover',
  solicitarAbertura: 'Solicitar abertura de processo',
  itens: 'Itens',
  Itens: 'Itens',
  observacao: 'Observação',
  anexarArquivos: 'Anexar arquivos',
  arquivosAnexados: 'Arquivos anexados',
  adicionarArquivos: 'Adicionar arquivo',
  salvar: 'Salvar',
  tipoDocumento: 'Tipo de documento',
  escolherArquivo: 'Escolher arquivo',
  unidadeComercializada: 'Un. de medida comercializada',
  carregando: 'Carregando',
  tooltipMercosul:
    'Nomenclatura comum do Mercosul (código que auxilia na identificação dos produtos que circulam no Brasil, Argentina, Paraguai, Uruguai e demais países do Mercosul)',
  modificar: 'Modificar',
  cadastrarProduto: 'Cadastrar produto',
  editarProduto: 'Editar produto',
  adicionarProduto: 'Adicionar produto',
  adicionadoProduto: 'Produto adicionado',
  produtoAdicionado: 'Produto adicionado! Cadastrar Produto?',
  indice: 'Índice',
  todosCamposObrigatorios: 'Todos os campos são obrigatórios',
  preenchaCamposObrigatorios: 'Por favor preencha todos os campos obrigatórios',
  confirmarRemoverLista: 'Voce tem certeza de que quer remover este produto da lista?',
  cadastroFuturo: 'Você pode cadastrá-lo de novo futuramente.',
  editarReferencia: 'Editar referência',
  codigoCliente: 'Código Cliente',
  grupo: 'Grupo',
  fornecedor: 'Fornecedor',
  produtor: 'Produtor',
  produtorFabricante: 'Produtor / Fabricante',
  Fornecedor: 'Fornecedor',
  Produtor: 'Produtor',
  codigoTrust: 'Código Trust',
  textoNCM:
    'Ao cadastrar, você conseguirá utilizar este mesmo produto em outras operações, quando digitar o NCM.',
  cadastrar: 'Cadastrar',
  Importador: 'Importador',
  // LISTAGEM DE PROCESSOS
  listagemProcessos: 'Listagem de processos',
  processosAfiliados: 'Follow-Up Afiliados',
  tituloTooltipListagemProcessos: 'Todos os processos em lista, podendo filtrar \ne salvar em modelos para facilitar o uso.',
  relatorioSalvo: 'Relatório salvo com sucesso',
  relatorioAtualizado: 'Relatório atualizado com sucesso',
  relatorioSemDescricao: 'O relatório não pode ser salvo sem uma descrição',
  modeloRelatorios: 'Modelos de relatórios',
  criarModeloRelatorio: 'Criar um novo modelo de relatório',
  alterarModeloRelatorio: 'Atualizar modelo de relatório',
  digiteAqui: 'Digite aqui',
  digiteAquiNCM: 'Busque aqui por NCM',
  selecioneColunas: 'Selecione as colunas que você deseja exibir',
  criarRelatorio: 'Criar relatório',
  atualizarRelatorio: 'Atualizar relatório',
  relatorioAplicado: 'Relatório aplicado',
  listagem: 'Lista',
  deferimentoLi: 'Deferimento LI',
  // INVENTARIO
  de: 'de',
  fraseEstoqueMiniRefpart1: 'O valor de referência é o estoque atual. Isso significa que se o checkbox for marcado o estoque minimo sera',
  fraseEstoqueMiniRefpart2: '% estoque atual disponível',
  estoqueMinimoMensagemPorcentagemAviso: 'Ao selecionar estoque por porcentagem deve ser entre 1 e 200',
  valorPorPercentagemEstoque: 'Estoque minimo por porcentagem (%) do atual',
  'Código do produto': 'Código do produto',
  'Nome do Produto': 'Nome do Produto',
  'Categoria do NCM': 'Categoria do NCM',
  'Previsão no armazém': 'Previsão no armazém',
  estabelecimento: 'Estabelecimento',
  descricaoGrupo: 'Descrição grupo',
  quantidadeAtual: 'Quantidade atual',
  situacao: 'Situação',
  descricaoEndereco: 'Descrição endereço',
  inventarioDescricao: 'Estoque referente ao dia anterior',
  descricaoProduto: 'Descrição produto',
  depositante: 'Depositante',
  tipoUnidade: 'Tipo de unidade',
  Dias: 'Dias',
  classe: 'Classe',
  quantidadeEmpenhado: 'Quantidade Empenhado',
  quantidadeReserva: 'Quantidade de Reserva',
  armazenadoEm: 'Armazenado em',
  quantidadeProdutosEmTransito: 'Quantidade de produtos em trânsito',
  quantidadeProdutosAtual: 'Quantidade de produtos atuais',
  // ARMAZEM
  // RELATORIOS
  adicionar: 'Adicionar',
  Habilitado: 'Habilitado',
  Descrição: 'Descrição',
  desabilitado: 'Desabilitado',
  'Dias da Semana': 'Dias da semana',
  Horário: 'Horário',
  horarioEnvio: 'Horário de envio',
  'E-mails': 'E-mails',
  editarRelatorio: 'Editar relatório',
  adicionarRelatorio: 'Criar relatório',
  conteudoRelatorio: 'Conteúdo do relatório',
  escolhaColunasFiltros: 'Escolha as colunas ou selecione um filtro favoritado',
  escolhaColunasFiltrosIntro1: 'Você pode favoritar um filtro com as opções de colunas que você preferir.',
  escolhaColunasFiltrosIntro2: 'Essa funcionalidade também está disponível na listagem de processos, podendo filtrar por lá a visualização de processos conforme sua necessidade.',

  habilitarAgendamento: 'Habilitar agendamento',
  cancelar: 'Cancelar',
  naoCancelar: 'Não cancelar',
  excluirAgendamento: 'Excluir agendamento de relatório?',
  naoRecuperavel: 'Uma vez excluído, não é possível recuperar',
  excluirAberturaProcesso: 'Você deseja solicitar o cancelamento do processo?',
  nossosEspecialistasVao:
    'Nossos especialistas vão receber sua solicitação e lhe retornaremos por e-mail com os ajustes',
  recuperavel: 'É possível recuperar após a exclusão.',
  excluido: 'Excluído com sucesso',
  voltarAgendamentos: 'Vamos retornar à listagem de agendamentos',
  tenteNovamente: 'Por favor, tente novamente',
  confirmar: 'Confirmar',
  'Un. de Negócio': 'Un. de Negócio',
  'Un. de Medida': 'Un. de Medida',
  // INCENTIVO FISCAL
  incentivoFiscal: 'Incentivo Fiscal',
  icmsPago: 'ICMS Pago',
  aliquotaIcmsPago: 'Alíquota ICMS pago',
  formaDesconto: 'Forma desconto',
  descontoIcmsPago: 'Desconto ICMS pago',
  pctCliente: '% BC Cliente',
  pctGanhoLiquido: '% Ganho Líquido',
  valorCliente: 'Valor Cliente',
  porcentagemCliente: '% Cliente',
  pctEmpresa: '% Empresa',
  // GED
  ged: 'Gerenciamento eletrônico de documentos',
  tituloTooltipGed: 'Documentos referentes aos últimos 90 dias, para documentos mais antigos, alterar o filtro.',
  baixarSelecionados: 'Baixar selecionados',
  visualizarSelecionados: 'Visualizar Selecionados',
  Documento: 'Documento',
  Tipo: 'Tipo',
  Extensão: 'Extensão',
  arquivoNaoSuportado: 'O arquivo deve ter a extensão xlsx, xls ou csv',
  Data: 'Data',
  // USUARIOS,
  Foto: 'Foto',
  Código: 'Código',
  'Criado em': 'Criado em',
  'Nome completo': 'Nome completo',
  Email: 'E-mail',
  senha: 'Senha',
  confirmarSenha: 'Confirmar senha',
  criarSenha: 'Criar senha',
  caracteresSenha: 'De 8 à 25 caracteres',
  maiusculas: 'Pelo menos uma letra maiúscula e uma minúscula',
  letrasNumeros: 'Letras e números',
  caractereEspecial: "Caractere especial ! @ # $ % & * ' _ + = [ ] { } | : . ? ~ ( ) ; ,",
  adicionarUsuario: 'Adicionar usuário',
  editarUsuario: 'Editar usuário',
  CNPJContatos: 'CNPJs e contatos responsáveis',
  notificacoes: 'Notificações',
  fotoPerfil: 'Foto de perfil',
  opcional: 'Opcional',
  empresas: 'Empresas',
  empresa: 'Empresa',
  tituloTooltipEmpresas: 'Visualize o DNA e os responsáveis das empresas cadastradas',
  nomeEmpresa: 'Nome empresa',
  tipoUsuario: 'Tipo de usuário',
  responsavelComercial: 'Responsável comercial',
  nome: 'Nome',
  responsavelOperacional: 'Responsável operacional',
  clientesCNPJ: 'CNPJ Vinculados',
  consultarCNPJ: 'Vincular CNPJ',
  'Cód. Conexos': 'Cod. Conexos',
  Nome: 'Nome',
  Cidade: 'Cidade',
  UF: 'UF',
  'Razão Social': 'Razão Social',
  adicionarSelecionados: 'Adicionar selecionados',
  receberNotificacoes: 'Receber notificações',
  notificacoesWhatsapp: 'Notificações no WhatsApp',
  tipoNotificacao: 'Tipo de notificação',
  // DASHBOARD
  bemVindo: 'Bem-vindo',
  tempoLiberacao: 'Tempo de liberação (dias)',
  tempoLiberacaoProduto: 'Tempo de liberação por produto (dias)',
  top10Produtos: 'Top 10 produtos',
  acertoNumerario: 'Acerto de numerário (%)',
  tempoMedioFechamento: 'Tempo médio de fechamento (dias)',
  processos: 'Processos',
  processoAberto: 'Seu processo foi aberto com sucesso.',
  statusProcesso: 'Status do processo (%)',
  faturamento: 'Faturamento',
  emTempo: 'Em tempo',
  verde: 'Verde',
  vermelho: 'Vermelho',
  amarelo: 'Amarelo',
  cinza: 'Cinza',
  Janeiro: 'Janeiro',
  Fevereiro: 'Fevereiro',
  Março: 'Março',
  Abril: 'Abril',
  Maio: 'Maio',
  Junho: 'Junho',
  Julho: 'Julho',
  Agosto: 'Agosto',
  Setembro: 'Setembro',
  Outubro: 'Outubro',
  Novembro: 'Novembro',
  Dezembro: 'Dezembro',
  janeiro: 'Janeiro',
  fevereiro: 'Fevereiro',
  marco: 'Março',
  abril: 'Abril',
  maio: 'Maio',
  junho: 'Junho',
  julho: 'Julho',
  agosto: 'Agosto',
  setembro: 'Setembro',
  outubro: 'Outubro',
  novembro: 'Novembro',
  dezembro: 'Dezembro',
  // Financeiro
  modalidade: 'Modalidade',
  porcentagem: 'Porcentagem',
  tipoVencimento: 'Tipo vencimento',
  dataVencimento: 'Data de vencimento',
  valor: 'Valor',
  undefined: 'Objeto não encontrado',
  // Mensageiro
  mensageiro: 'Mensageiro',
  tituloTooltipMensageiro:
    'Agende o envio de relatórios para o e-mail sobre seus processo \ne fique por dentro das atualizaçôes que ocorrem.',
  Responsável: 'Responsável',
  'Última execução': 'Última vez executado',
  excluirAgendamentoPadrao: 'Excluir agendamento?',
  excluirProduto: 'Excluir produto?',
  enviarEmail: 'Enviar e-mail agora',
  agendamento: 'Agendamento',
  editarAgendamento: 'Editar agendamento',
  agendar: 'Agendar',
  erroSalvarAgendamentoMensageiro: 'Ocorreu um erro ao salvar o agendamento!',
  agendamentoSalvoComSucesso: 'Agendamento salvo com sucesso',
  redirecionamentoTelaListagem: 'Você será redirecionado para tela de listagem.',
  preenchaTodoAgendamento: 'Por favor preencha todos os campos para realizar o agendamento.',
  preenchaHorarios: 'Por favor, selecione ao menos um horário para agendamento',
  preenchaEmails: 'Por favor, digite ao menos um e-mail válido',
  preenchaDescricao: 'Por favor, preencha o campo de descrição',
  preenchaDias: 'Por favor, selecione ao menos um dia da semana para o agendamento',
  preenchaEmailInvalido: 'Email(s) inválido(s)',
  preenchaEmpresas: 'Por favor, selecione ao menos uma empresa para o agendamento',
  Copiar: 'Copiar',
  Reenviar: 'Reenviar',
  enviar: 'Enviar',
  enviarEmailAgora: 'Deseja realmente enviar o e-mail agora?',
  sucessoEnvioEmail: 'E-mail enviado com sucesso!',
  processoCompartilhadoSucesso: 'Os processos foram compartilhados com sucesso!',
  adiantado: 'Adiantado',
  obrigatorio: 'Atenção: Campo obrigatório.',
  emailInvalido:
    'O endereço de email digitado parece estar incorreto. Por favor, verifique e tente novamente',
  cnpjInvalido: 'Atenção: CNPJ Inválido.',
  senhaInvalida: 'Atenção: Senha não cumpre os requisitos',
  senhasDiferentes: 'Atenção: As senhas não conincidem',

  // notificacoes
  chegada: 'Chegada',
  ativarNotificacoes: 'Selecionar todas as notificações',
  embarquePrevisto: 'Embarque previsto',
  embarqueEfetivo: 'Embarque efetivo',
  manifestoCarga: 'Manifesto de carga',
  emailDestino: 'E-mails de destino',
  empresaSelecionadaNaoExiste: 'A empresa selecionada não está cadastrada',
  cadastroEmpresa: 'Cadastro de empresa',
  cadastroUsuario: 'Cadastro de usuário',
  emailEnviado: 'E-Mail enviado com sucesso',
  vincularEmpresa: 'Vincular empresas',
  frequencia: 'Frequência',
  campos: 'Campos',
  transitTime: 'Tempo de trânsito',
  tituloTooltipTransitTime:
    'Visualize o avanço dos proecesso entre \nas etapas e o tempo previsto para serem concluídos.',
  ano: 'Ano',
  dom: 'Dom',
  seg: 'Seg',
  ter: 'Ter',
  qua: 'Qua',
  qui: 'Qui',
  sex: 'Sex',
  sab: 'Sab',
  DI: 'DI',
  siscarga: 'Siscarga',

  // Tour
  tourCancelar: 'Cancelar',
  tourVoltar: 'Voltar',
  tourProximo: 'Próximo',
  tourFinalizar: 'Finalizar',

  tourBemVindo: 'Boas-Vindas!',
  tourBemVindoMensagem: 'Vamos lhe mostrar nossas principais funções, é rapidinho.',

  tourMapa: 'Mapa',
  tourMapaMensagem: 'Visualize o rastreio de cargas marítimas, rodoviárias e também os portos, armazéns e fabricantes.',

  tourDashboard: 'Dashboard',
  tourDashboardMensagem: 'Consulte os gráficos e estatísticas de seus processos, produtos, numerário entre outras informações.',

  tourFollowUp: 'Follow-Up',
  tourFollowUpMensagem: 'Acompanhe seu processo pelas etapas de importação.',

  tourMenu: 'Menu',
  tourMenuMensagem: 'Menu expansivel que lhe entrega o acesso aos demais módulos disponiveis no sistema.',

  tourProcessos: 'Abrir Processos',
  tourProcessosMensagem: 'Abra processos e aguarde o andamento',

  tourGestaoLi: 'Gestão LI',
  tourGestaoLiMensagem: 'Verifique as licenças necessárias para importação.',

  tourDocumentos: 'Documentos',
  tourDocumentosMensagem: 'Analise documentos referentes aos seus processos.',

  tourAgendarRelatorios: 'Agendar Relatórios',
  tourAgendarRelatoriosMensagem: 'Programe relatórios personalizados para receber via e-mail.',

  tourUsuarios: 'Usuários',
  tourUsuariosMensagem: 'Adicione e configure usuários para fazerem uso do sistema com você.',

  tourSelecaoEmpresas: 'Seleção de Empresas',
  tourSelecaoEmpresasMensagem: 'Com o CNPJ filtre as empresas que deseja visualizar.',

  tourChat: 'Chat',
  tourChatMensagem: 'Tire dúvidas e troque informações com nossa IA ou com os especialistas.',

  tourTema: 'Temas',
  tourTemaMensagem: 'Alterne entre o tema claro e o tema escuro',

  tourNotificacoes: 'Notificações',
  tourNotificacoesMensagem: 'Consulte as atualizações dos processos e a configure o envio pelo e-mail.',

  tourPerfil: 'Perfil',
  tourPerfilMensagem: 'Edite seus dados, contemple as novidades da nossa plataforma, veja o tour novamente ou troque de conta de acesso.',

  tourMapaFuncionalidade: 'Opções do Mapa',
  tourMapaFuncionalidadeMensagem: 'Você pode centralizar, aumentar e reduzir o zoom do mapa.',

  tourMapaFiltros: 'Filtros do Mapa',
  tourMapaFiltrosMensagem: 'Opção para filtrar os processos dependendo do status.',

  tourObrigado: 'Obrigado pela atenção',
  tourObrigadoMensagem: 'Se ainda ficar com dúvidas, entre contato com nossa equipe.',

  removerDemanda: 'Você deseja remover esta demanda?',
  possivelRecuperar: 'É possível recuperar após a exclusão',
  proximo: 'Próximo',
  disponivelNCM:
    'O item ficará cadastrado em nosso banco de dados e você conseguirá reutilizar este item em operações futuras.',
  fechar: 'Fechar',
  preenchaTudo: 'Preencha todos os campos antes de cadastrar um item.',
  produtoSalvo: 'Produto cadastrado com sucesso!',
  produtoJaCadastrado: 'Produto já esta cadastrado',
  produtoDeletado: 'Produto deletado com sucesso!',
  ncmAutomatico:
    'Digite o código da NCM, se o mesmo estiver no nosso banco de dados, as informações serão preenchidas automaticamente, parcial ou totalmente.',
  configuracoes: 'Configurações',
  statusAlterado: 'Status alterado',
  hoje: 'Hoje',
  ontem: 'Ontem',
  estaSemana: 'Esta semana',
  semanaPassada: 'Semana passada',
  esteMes: 'Este mês',
  anteriores: 'Anteriores',
  assimQueAtualizar: 'Assim que atualizar',
  diariamente: 'Diariamente',
  semanalmente: 'Semanalmente',
  desabilitarEnvio: 'Desabilitar envio',
  dataRegistroDI: 'Registro DI',
  numeroProtocoloDI: 'Número protocolo DI',
  dataDesembaracoDI: 'Desembaraço DI',
  dataAbertura: 'Abertura',
  dataFechamentoOperacional: 'Fechamento Operacional',
  dataExecucaoCarregamento: 'Execução do Carregamento',
  carregamentoAgendado: 'Carregamento Agendado',
  dataFaturamento: 'Faturamento',
  dataEnvioFaturamento: 'Envio faturamento',
  emissaoNotaEntrada: 'Emissão nota de entrada',
  dataPresencaCarga: 'Presença de carga',
  conhecimentoEmbarque: 'Conhecimento de embarque',
  dataVistoriaMapa: 'Vistoria do Mapa',
  dataRecebimentoOriginais: 'Recebimento dos Originais',
  cadastrarUsuario: 'Cadastrar usuário',
  listarUsuario: 'Lista de usuários',
  legenda: 'Legenda',
  refazerTour: 'Refazer tour de ajuda',
  sairConta: 'Tem certeza que deseja sair?',
  zoomIn: 'Mais zoom',
  zoomOut: 'Reduzir zoom',
  centralizarMapa: 'Centralizar',
  registroNaoEncontrado: 'Registro não encontrado',
  processoNaoPossuiLocalizacaoMapa: 'O processo não possui localização geográfica registrada',
  avisoCamposObrigatorios: 'Campos marcados com * devem ser preenchidos obrigatoriamente.',
  maisDetalhes: 'Mais detalhes',
  codigoProduto: 'Código produto',
  lote: 'Lote',
  loteFabricacao: 'Lote fabricação',
  dataFabricacao: 'Data de fabricação',
  codigoPallet: 'Código do Pallet',
  codigoSequenciaLote: 'Sequência Lote',
  dataMovimentacao: 'Data de Movimentação',
  numeroLote: 'Número do Lote',
  numeroLoteFabricacao: 'Número do Lote Fabricação',
  quantidadeBloqueada: 'Quantidade bloqueada',
  quantidadeEmpenhada: 'Quantidade Empenhanda',
  carregarTemplate: 'Carregar template',
  importarModelo: 'Importar dados do modelo',
  baixarModelo: 'Baixar modelo',
  solteArquivos: 'Arraste e solte seus arquivos aqui.',
  arquivosPermitidos: 'Arquivos permitidos: XLSX, DOC e PDF.',
  solteCarregar: 'Solte os arquivos aqui para carregar.',
  carregandoArquivos: 'Carregando arquivos...',
  verifiqueAntesSalvar: 'Verifique os campos antes de salvar.',
  processoExiste: 'Este número de referência já existe, verifique.',
  valorTotal: 'Valor total',
  ncm: 'Código NCM',
  descricaoDetalhada: 'Descrição detalhada',
  produtos: 'Produtos',
  tituloTooltipProdutos: 'Cadastre itens para importá-los em seus \nprocessos e tenha o histórico de tudo.',
  // Mensagens de Validacoes cadastro de Produto
  valorUnitarioPositivo: 'O valor unitário deve ser maior que zero',
  quantidadePositivo: 'O campo quantidade deve ser maior que zero',
  preenchaCampoProdutor: 'O campo fabricante está vazio, por favor preencha',
  preenchaCampoFornecedor: 'O campo fornecedor está vazio, por favor preencha',
  preenchaCampoCodigoCliente: 'O campo código de cliente está vazio, por favor preencha',
  preenchaCampoProduto: 'O campo produto está vazio, por favor preencha',
  preenchaCampoUnidadeMedida: 'O campo unidade de medida está vazio, por favor preencha',
  preenchaCampoNCM: 'O campo de código do NCM está vazio, por favor preencha',
  preenchaCampoMoeda: 'O campo moeda está vazio, por favor selecione uma das moedas',
  preenchaCampoEmpresa: 'O campo empresa está vazio, por favor selecione uma das empresas',
  maximo10characteres: 'O campo deve conter no máximo 10 characteres',
  maximo20characteres: 'O campo deve conter no máximo 20 characteres',
  maximo100characteres: 'O campo deve conter no máximo 100 characteres',
  excluirUsuario: 'Excluir usuário?',
  //////////////////////////////// ERROS
  ERRO_INTERNO_SERVIDOR_LOGIN:
    'Lamentamos, mas ocorreu um erro interno em nosso servidor ao tentar fazer login. Estamos trabalhando para corrigir o problema e pedimos desculpas pelo inconveniente. Tente novamente em alguns minutos ou entre em contato com o suporte. Obrigado pela compreensão.',
  actions: 'Ações',
  acoes: 'Ações',
  //TAREFAS
  pendente: 'Pendentes',
  administrativo: 'Administrativo',
  aguardando: 'Aguardando',
  regulatorio: 'Regulatório',
  novoProduto: 'Novo produto',
  cadastroNovoProduto: 'Novo produto',
  regulatorioCadastroNovoProduto: 'Novo produto / regulatório',
  REGULATORIOCADASTRONOVOPRODUTO: 'Novo produto / regulatório',
  cadastros: 'Cadastros',
  cancelamentos: 'Cancelamentos',
  acompanhamento: 'Acompanhamento',
  liberacao: 'Liberação',
  nacionalizacao: 'Nacionalização',
  gestaoTarefas: 'Gestão de tarefas',
  id: 'ID',
  licenciamento: 'Licenciamento',
  validacaoRegulatorio: 'Validação do regulatório',
  historico: 'Histórico',
  processoMovido: 'Processo movido para',
  comentar: 'Comentar',
  reenviarAcesso: 'Você deseja enviar um email com um novo acesso? A senha atual será alterada.',
  tarefas: 'Tarefas',
  tarefasProcessoPendente: 'Processo pendente',
  tarefasTratamentoAdministrativo: 'Tratamento Administrativo',
  tarefaRegulatorioCadastroNovoProduto: 'Novo produto / regulatório',
  tarefasAcompanhamento: 'Acompanhamento de pós-embarque',
  tarefasLiberacao: 'Liberação',
  tarefasNacionalizacao: 'Nacionalização',
  tarefasFechamento: 'Fechamento',
  cardJaEstaEmAnaliseProduto: 'Este card já foi criado na etapa de Novo produto / Regulatório',
  cardDuplicadoMensagemVerificacao: 'O processo foi duplicado para permitir atividades simultâneas. Por favor, revise as etapas relacionadas ao Novo Produto e/ou Acompanhamento.',
  atividades: 'Atividades',
  atribuirMim: 'Atribuir a mim',
  proximaEtapa: 'Proxima etapa',
  sim: 'Sim',
  nao: 'Não',
  conferido: 'Conferido',
  filtrosFavoritos: 'Filtros favoritos',
  vincularFiltroModelo: 'Você deseja vincular a última pesquisa/filtro a este modelo?',
  salvarUmFiltro: 'Salvar um filtro',
  criarUmNovoFiltro: 'Criar um filtro favorito',
  editarFiltro: 'Editar filtro',
  filtroSalvo: 'Filtro salvo com sucesso',
  filtroAtualizado: 'Filtro atualizado',
  fltroAplicado: 'Filtro aplicado',
  envioDocumentosFechamento: 'Envio de documentos',
  envioDocumentosFechamentoFisicos: 'Envio de documentos fisicos',
  editarObservacao: 'Editar observação',
  regulatoriocadastronovoproduto: 'regulatório e cadastro novo produto',
  confirmarNovoProduto: 'Confirmar novo produto',
  concluidos: 'Concluidos',
  esconderColunaConcluidos: 'Esconder coluna de concluidos',
  exibirColunaConcluidos: 'Exibir coluna de concluidos',
  // Tarefas atividades administrativo
  aberturaProcessoConexos: 'Abertura de processo no conexos',
  aberturaPastaNuvem: 'Abertura de pasta na nuvem',
  responderEmailAbertura: 'Responder e-mail de abertura',
  tratamentoTributario: 'Tratamento tributário / Classificação Fiscal NCM / Administrativo',
  instrucaoDespacho: 'Instrução de despacho - ID',
  verificacaoCadastroProduto: 'Verificação de cadastro do produto / Fornecedores',
  lancamentoCadastroInvoice: 'Lançamento / Cadastro de Invoice no Conexos',
  conferenciaDocumental: 'Conferência documental',
  solicitacaoFreetime: 'Solicitação de Free-time',
  simulacaoCliente: 'Enviar simulação do cliente',
  emissaoLiPreEmbarque: 'Emissão do LI Pré-embarque',
  cotacaoFreteInternacional: 'Cotação Frete Internacional',
  fechamentoCambio: 'Fechamento de câmbio',
  provisionamentoCambio: 'Provisionamento de câmbio',
  acompanhamentoDeferimentoLiPosEmbarque: 'Deferimento LI pós-embarque',
  emitirLi: 'Emitir LI',
  liPre: 'LI pré',
  liPos: 'LI pós',
  semLi: 'Sem LI',
  solicitadoNF: 'Solicitado NF',
  checklistNotaRealizado: 'Checklist nota realizado',
  solicitacaoEmissaoEnviadoFaturamento: 'Solicitação de emissão enviado o fatuamento',
  digitarLI: 'Digitar LI',
  // Tarefas atividades novoProduto
  recebimentoDescricao: 'Recebimento de descrição / NCM / Dados do fornecedor',
  formularioCadastroProduto: 'Formulário para cadastro de produto',
  formularioCadastroFornecedores: 'Formulário para cadastro de fornecedores',
  aberturaChamadoCadastro: 'Abertura de chamado de cadastro',
  produtoCadastrado: 'Produto cadastrado',
  liberadoImportacao: 'Liberado importação',
  armazenagem: 'Armazenagem',
  transporte: 'Transporte',
  // Tarefas atividade regulatório
  envioFormularioRegulatorio: 'Envio de formulário para o Regulatório',
  envioDocumentos: 'Envio de documentos / MSDS / FISPIQ',
  pendenciaDocumental: 'Pendência documental / informações',
  analiseRegulatorioLiberado: 'Análise Regulatório Liberado',
  // Tarefas atividade acompanhamento
  cadastroConhecimentoConexos: 'Cadastro de conhecimento de embarque no conexos',
  documentosOriginais: 'Documento originais',
  recebimentoDocumentosOriginais: 'Recebimento de documento originais',
  telex: 'Telex',
  conferenciaCeMercante: 'Conferência CE Mercante',
  envioNumerario: 'Envio numerário',
  digitacaoDI: 'Digitação de DI',
  lancamentoMapaMadeira: 'Lançamento Mapa Madeira',
  verificacaoValorConta: 'Verificação de valor em conta',
  autorizacaoRegistroDI: 'Autorização de registro DI / AFRMM',
  provisionamentoNumerarioEncomendaPadrao: 'Provisionamento numerário encomenda padrão',
  liberacaoSiscargaBL: 'Liberação Siscarga/BL',
  envioParaAnuencia: 'Envio para anuência',
  blRetirado: 'B/L Retirado',
  solicitacaoRemocaoDTA: 'Solicitação de remoção DTA',
  solicitacaoRemocaoDTC: 'Solicitação de remoção DTC',
  // Tarefas atividades nacionalizacao
  envioDiRegistrada: 'Envio de DI registrada',
  envioCI: 'Envio da CI',
  liberacaoBL: 'Liberação de BL',
  desbloqueioSiscarga: 'Desbloqueio do Siscarga',
  solicitarExoneracaoICMS: 'Solicitar exoneração ICMS',
  montarNF: 'Montar NF / Conferir despesas para NF',
  liberacaoComex: 'Liberação comex',
  recebimentoNfTrust: 'Recebimento NF Trust',
  programacaoCarregamento: 'Programação de carregamento cliente e transporte',
  liberacaoFaturamentoTerminal: 'Liberação de faturamento do terminal',
  agendamentoRetirada: 'Agendamento de retirada',
  minutaDevolucaoCNTR: 'Minuta devolução CNTR',
  lavacaoAvaria: 'Lavação / Avaria',
  aguardandoRIC: 'Aguardando RIC',
  envioFechamento: 'Envio para fechamento',
  exoneradoAguardando: 'Aguardando exoneração ou Exonerado',
  icmsExonerado: 'ICMS exonerado',
  ricPendente: 'RIC pendente',
  ricRecebida: 'RIC recebida',
  cobrarRIC: 'Cobrar RIC',
  numerarioComplementar: 'Numerário complementar',
  recebimentoNumerarioComplementar: 'Recebimento numerário complementar',
  recebimentoNF: 'Recebimento NF',
  mapaLiberado: 'Mapa liberado',
  liberarMapa: 'Liberar Mapa',
  // Tarefas atividades fechamento
  acompanharProcesso: 'Acompanhar fechamento processo',
  // USUARIOS
  usuarioRemovido: 'Usuário excluído com sucesso',
  acessoEnviado: 'O acesso foi enviado para o email do usuário',
  excluirProprioUsuario: 'Você não pode excluir seu próprio usuário!',
  naoPodeReenviar: 'Você não pode reenviar o próprio email e primeiro acesso!',
  usuarioAtualizado: 'Usuário atualizado com sucesso!',
  usuarioInserido:
    'Usuário inserido com sucesso! Aguarde a senha ser gerada e enviada para o email',
  naoRecuperouUsuario: 'Não foi possível recuperar os dados do usuário!',
  formatoInvalido: 'O formato do campo é inválido!',
  nomeLetras: 'O nome deve conter no mínimo 3 letras!',
  nomeMaxLetras: 'O nome deve conter no máximo 50 letras!',
  campoObrigatorio: 'Este campo é obrigatório!',
  emailFormato: 'Formato de e-mail inválido.',
  emailMaxLetras: 'O campo e-mail deve conter no máximo 80 letras!',
  especifiqueUsuario: 'Especifique o tipo de usuário',
  senhaLetras: 'A senha deve conter no mínimo 8 caracteres.',
  senhaMaxLetras: 'A senha deve conter no máximo 25 caracteres.',
  senhaDiferentes: 'As senhas não são iguais.',
  limpar: 'Limpar',
  ativo: 'Ativo',
  desativado: 'Desativado',
  naoDigiteUnidadeMedida: 'Não digite a unidade de medida',
  avisoViaEmail: 'Receber um aviso via e-mail?',
  emailsDestinos: 'E-mails de destinos',
  estoque: 'Estoque',
  estoqueDisponivel: 'Estoque disponível',
  estoqueLimite: 'Estoque acabando ou esgotado',
  receberAvisoEstoqueText: 'Indicar na tabela quando o estoque estiver em *',
  estoqueMinimoAtualizadoSucesso: 'O estoque minímo foi atualizado com sucesso.',
  minimoEstoqueDesejado: 'Estoque mínimo desejado',
  naoDefinido: 'Não definido',
  legendaSemConfiguracaoEstoqueMinimo: 'Configuração não definida',
  legendaEmailDesativadoErroEstoqueMinimo: 'Estoque abaixo do limite e e-mail desativado',
  legendaEmailDesativadoEstoqueMinimo: 'Estoque disponível e e-mail desativado',
  legendaEstoqueMinimoAlerta: 'Estoque abaixo do limite',
  legendaEstoqueMinimoErro: 'Estoque esgotado',
  legendaEstoqueMinimoIdeal: 'Estoque disponível',
  formatoCampoEmailInvalido: 'Formato de email inválido, por favor verifique',
  requiredFieldValorEstoqueMinimo: 'Campo de estoque minimo está vazio, por favor preencha',
  requiredFieldTypeErrorNumber: 'Campo deve ser preenchido com numeros',
  requiredFieldEmail: 'Campo e-mail vazio, por favor preencha-o',
  historicoCompleto: 'Modo histórico completo',
  descricaoHistorico:
    "<p>O modelo histórico traz em cada e-mail de atualização <span style='text-decoration: underline'>todas as etapas percorridas</span> pelo processo com datas e contexto. Você pode ativar o botão e receber neste formato.</p> <p>Caso deixe desabilitado, o conteúdo do e-mail será apenas a última atualização.</p>",
  // AG-GRID
  equals: 'Igual',
  notEqual: 'Diferente de',
  blank: 'Vazio',
  notBlank: 'Não vazio',
  contains: 'Contém',
  notContains: 'Não contém',
  startsWith: 'Começa com',
  endsWith: 'Termina com',
  filter: 'filtro',
  andCondition: 'E',
  orCondition: 'OU',
  busqueCNPJ: 'Busque as empresas pelo nome ou CNPJ.',
  removerEmpresas: 'Remover empresas',
  aplicar: 'Aplicar',
  cliqueCardDetalhes: 'Clique no card para mais detalhes',
  fechamento: 'Fechamento',
  pending: 'Pendente',
  in_transit: 'Em trânsito',
  occurrence_treatment: 'Tratando ocorrência',
  done: 'Entregue',
  motorista: 'Motorista',
  placa: 'Placa',
  valorNF: 'Valor NF',
  pesoRealNF: 'Peso real NF',
  tituloEstoqueMinimo: 'Estoque mínimo',
  buscaAvancada: 'Busca avançada',
  codProcesso: 'Cód. Processo',
  paisOrigem: 'País origem',
  paisDestino: 'País destino',
  placaRodoviario: 'Placa (Rodoviário)',
  dataEntregaContainer: 'Data de entrega container',
  removerSelecionados: 'Remover selecionados',
  marcarDesmarcarTodos: 'Marcar / desmarcar todos',
  // LI
  digitarDI: 'Digitar DI',
  gestaoLicencasImportacao: 'Licenças de Importação',
  gestaoLI: 'Gestão de L.I.',
  licencaImportacao: 'Licença de Importação',
  visualizeLI:
    'Acompanhe as licenças necessárias para a importação, visando a regulamentação do comércio internacional e proteção da economia nacional.',
  dataSituacao: 'Data Situação',
  li: 'LI',
  dataReg: 'Data Reg.',
  validadeSituacao: 'Validade Situação',
  dataProtocolo: 'Data Protocolo',
  anuencia: 'Anuência',
  paraAnalise: 'Para análise',
  emExigencia: 'Em exigência',
  deferida: 'Deferida',
  encaminhar: 'Encaminhar',
  encaminharProcessoEmail: 'Encaminhar processo por email',
  verMais: 'Ver mais',
  verMenos: 'Ver menos',
  dataTransbordo: 'Transbordo',
  dataTransbordo2: 'Segundo transbordo',
  sequencia: 'Sequência',
  ultimoAcesso: 'Último acesso',
  cliqueAdicionarProduto: 'Clique para adicionar novo produto',
  house: 'BL House',
  master: 'BL Master',
  tipoContainer: 'Tipo de container',
  armador: 'Armador',
  lacre: 'Lacre',
  dataChegadaContainer: 'Chegada do Container',
  vencimentoFreetime: 'Vencimento Freetime',
  situacaoEvento: 'Situação do Evento',
  containerDevolvido: 'Contêiner Devolvido',
  dataEvento: 'Data do Evento',
  situacaoEventoArmador: 'Situação do Evento pelo Armador',
  nomeNavio: 'Nome do Navio',
  localEvento: 'Local do Evento',
  identificacaoViagem: 'Identificação da Viagem',
  dataViagem: 'Data da Viagem',
  Modalidade: "Modalidade",
  Porcentagem: "Porcentagem",
  Valor: "Valor",
  Invoice: 'Invoice',
  Abertos: "Abertos",
  Encerrados: "Encerrados",
  'Tipo vencimento': 'Tipo de Vencimento',
  statusDoProcesso: 'Status do processo',
  reenviarEmailProcesso: 'Reenviar e-mail do processo',
  erroAoEnviarEmail: 'Ocorreu um erro ao enviar o e-mail',
  aperteEnterParaCadaEmail: 'Aperte a tecla enter para cada endereço de e-mail digitado',
  tipoDeImportacao: 'Tipo de importação',
  cliqueParaBaixar: 'Clique para baixar',
  extratoLI: 'Extrato da L.I',
  // ged
  documentoBaixadoSucesso: 'Documento baixado com sucesso',
  erroBaixarDocumento: 'Ocorreu um erro ao baixar o documento',
  erroVisualizarDocumento: 'Ocorreu um erro ao visualizar o documento',
  //Produtos Processos
  'PET - RESINA': 'PET - RESINA',
  'PVC - RESINA': 'PVC - RESINA',
  'PROPRIO DIVERSOS': 'PROPRIO DIVERSOS',
  'SUPLEMENTOS': 'SUPLEMENTOS',
  // gestao containers
  containersNaoEncontrados: 'Containers não encontrados para este tipo de filtro',
  // GRÁFICOS
  indicadores: 'Indicadores',
  licencasDeferidas: 'Licenças deferidas',
  comExigencia: 'Com exigência',
  semExigencia: 'Sem exigência',
  tempoAberturaDeferimento: 'Tempo de abertura até o deferimento (dias)',
  expectativaChegada: 'Expectativa de chegada',
  codCalculo: 'Código cálculo receita/custo',
  estadoCalculo: 'Estado cálculo receita/custo',
  dataInicio: 'Data início',
  dataFim: 'Data fim',
  valorServico: 'Valor do serviço',
  valorCalculado: 'Valor calculado',
  ordemCompra: 'Ordem de compra',
  aVista: 'À vista',
  aPrazo: 'À prazo',
  termosPagamento: 'Termos do pagamento',
  portoOrigem: 'Porto origem',
  portoDestino: 'Porto destino',
  enderecoExportador: 'Endereço exportador',
  selecionarCNPJ: 'Selecione e adicione os CNPJs ao usuário',
  vincular: 'Vincular',
  // TabName
  'Login': 'Login',
  'Home': 'Home',
  'AberturaProcesso': 'Abertura de Processo',
  'ProcessosKanban': 'Follow-Up',
  'GestaoLI': 'Gestão de LI',
  'ListagemProcesso': 'Listagem de Processos',
  'TransitTime': 'Transit Time',
  'Estoque': 'Estoque',
  'Financeiro': 'Financeiro',
  'AgendamentoRelatorios': 'Relatórios',
  'Ged': 'Gerenciamento Eletrônico de Documentos',
  'Mensageiro': 'Mensageiro',
  'Tarefas': 'Gestão de Tarefas',
  'ListarUsuarios': 'Usuários',
  'Produtos': 'Produtos',
  'Dashboard': 'Dashboard',
  'Empresas': 'Empresas',
  'Manutencao': 'Manutenção',
  'RecuperarSenha': 'Esqueceu sua senha',
  'processosParceiros': 'Parceiros',
  'processosComissao': ' Parceiros',
  bugs: 'Bugs: ',
  melhorias: 'Melhorias: ',
  manutencao: 'Manutenção: ',
  novidades: 'Novidades: ',
  patchNotes: 'Notas de Atualização',
  assistente: 'Assistente',
  assistente1: 'Assistente 1',
  assistente2: 'Assistente 2',
  assistentes: 'Assistentes',
  introPatchNotes1: 'Essas são apenas algumas das melhorias e funcionalidades introduzidas em cada versão do trinity. Estamos sempre empenhados em aprimorar a plataforma e oferecer a você a melhor experiência possível.',
  introPatchNotes2: 'Estaremos compartilhando informações sobre futuras versões e recursos emocionantes que estão por vir.',
  manutencoes: 'Manutenções',
  aguardandoAtualizacao: 'Aguardando atualização',
  copiarLinkProcesso: 'Copiar link do processo',
  estrategico: 'Estratégico',
  chat: 'Chat',
  entendi: 'Entendi',
  aindaNaoEmbarcado: 'Ainda não foi embarcado',
  seuProcessoAindaNaoEmbarcado: 'Seu processo ainda não foi embarcado.',
  fiqueOlho: 'Fique de olho nos próximos dias.',
  ops: 'Oops',
  processoNaoEncontrado: 'Este processo não foi encontrado',
  naoRegistrado: 'Pode ser que seu navio esteja numa área sem radar ou que o navio não tenha sido registrado.',
  transporteAereo: 'Transporte aéreo',
  seuProcessoAereo: 'Seu processo está na modalidade de transporte aéreo.',
  naoApareceMapa: 'No momento esta modalidade não aparece no mapa.',
  transitoConcluido: 'Trânsito concluído',
  processoNaoTransito: 'Seu processo não está mais em trânsito.',
  cliqueDetalhesProcesso: 'Clique para conferir os detalhes deste processo.',
  verDetalhes: 'Ver detalhes',
  // CRC
  crcMenu: 'Custo Armaz...',
  crc: 'Custo do Armazém',
  codigoCRC: 'Código Cálculo Receita/Custo',
  estadoCRC: 'Estado Cálculo Receita/Custo',
  descricaoServico: 'Descrição serviço',
  quantidadeServico: 'Quantidade serviço',
  editarEmpresa: 'Editar empresa',
  // Cadastros
  cadastroBasico: 'Cadastros básicos',
  fornecedorProdutor: 'Fornecedor / Produtor',
  siglaSimbolo: 'Sigla/Simbolo',
  Cadastro: 'Cadastro',
  salvoComSucesso: 'salvo com sucesso',
  deletadoComSucesso: 'foi deletado com sucesso',
  sigla: 'Sigla',
  tipo: 'Tipo',
  alta: 'Alta',
  media: 'Média',
  baixa: 'Baixa',
  prioridade: 'Prioridade',
  // DNA Empresas
  sequencial: 'Sequencial',
  questionario: 'Questionário',
  questionarios: 'Questionários',
  perguntas: 'Perguntas',
  respostas: 'Respostas',
  perguntasAndRespostas: 'Perguntas e Respostas',
  responsavelComex: 'Responsável comex',
  assistenteComex: 'Assistente comex',
  responsavelExecutivo: 'Responsável executivo',
  //
  totalProcessosDescricao: 'Processos em andamento por status',
  statusProcessosDescricao: 'Em relação ao previsao de embarque original',
  canalParametrizacaoDescricao: 'Em relação aos processos em andamento',
  topProdutosDescricao: 'Em relação a quantidade de notas',
  acertoNumerarioDescricao: 'Em relação entre valor Previsto vs  valor Realizado',
  //
  tempoLiberacaoFechamentoDescricao: 'Em relação a data da presenca da carga',
  placeholderFornecedorProdutorInputNome: 'Empresa exemplo ltda.',
  placeholderFornecedorProdutorInputCNPJ: '00.000.000/0001-00',
  placeholderMoedaInputSiglaSimbolo: 'USD',
  placeholderMoedaInputDescricao: 'Dollar Americano',
  placeholderUnidadeMedidaInputSiglaSimbolo: 'KG',
  placeholderUnidadeMedidaInputDescricao: 'Quilogramas',
  recuperarRascunho: 'Retomar rascunho',
  previsao: 'Previsão', mensagemAddInformacaoCadastroBasico: 'Se deseja adicionar um novo item, por favor, entre em contato com um administrador.',
  mensagemCampoDescricaoCadastroBasico: 'O campo descrição deve conter no mínimo 5 caracteres.',
  mensagemCampoSiglaMoeda: 'O campo sigla deve conter no mínimo 3 caracteres.',
  mensagemCampoSiglaUnidadeMedida: 'O campo sigla deve conter no mínimo 2 caracteres.',
  mensagemCampoNomeFornecedorProdutor: 'O campo nome deve conter no mínimo 5 caracteres.',
  mensagemCampoCNPJFornecedorProdutor: 'O campo CNPJ não precisa ser formatado; apenas os números são suficientes.',
  mensagemCampoCNPJLenghtFornecedorProdutor: 'O campo CNPJ deve conter 14 caracteres.',
  cadastrosBasicos: 'Cadastro básicos',
  // Simulação
  Simulacao: 'Simulação',
  simulacao: 'Simulação',
  classificacao: 'Classificação',
  filial: 'Filial/Benefícios',
  solicitadoEm: 'Solicitado em',
  recuperarSenha: 'Recuperar senha',
  nenhumaEmpresaColuna: 'Nenhuma empresa nessa coluna',
  nunhumProcessoEncontrado: 'Nenhum processo novo foi encontrado',
  abrirVisualizarAndamentoFollowup: 'Você pode abrir um novo processo ou visualizar o que está em andamento no Follow-Up',
  tooltipDataLiberacaoSiscarga: 'Data da liberação do B/L (retirada da retenção)',
  tooltipDataLiberacaoMapa: 'Data em que o ministério da agricultura efetua a liberação das embalagens de madeira da mercadoria',
  tooltipPresencaCarga: 'Data em que o recinto aduaneiro informa que o container está no terminal',
  LI: 'LI',
  II: 'II',
  IPI: 'IPI',
  PIS: 'PIS',
  COFINS: 'COFINS',
  'COFINS CUSTO': 'COFINS CUSTO',
  ICMS: 'ICMS',
  'PIS SAIDA': 'PIS SAIDA',
  'COFINS SAIDA': 'COFINS SAIDA',
  'MARKUP': 'MARKUP',
  'DESCONTO': 'DESCONTO',
  taxaTrust: 'Taxa Trust',
  'TAXA TRUST': 'Taxa Trust',
  comissoes: 'Comissões',
  parceiros: 'Importar Faz Crescer',
  DashboardContainers: "Dashboard",
  min: "Mínimo",
  max: "Máximo",
  avg: "Média",
  median: "Mediana",
  count: "Contagem",
  escolhaAbaixo: 'Escolha abaixo',
  //Mercado Hoje
  mercadoHojeTitulo: 'Mercado hoje',
  mercadoHoje: 'Mercado hoje',
  precoMedio: 'Preço médio',
  pesoLiquido: 'Peso líquido',
  pesoBruto: 'Peso bruto',
  referenciaProcesso: 'Referência do processo',
  valorComissao: 'Valor da comissão',
  parcelasPagamento: 'Parcelas de pagamento',
  dataComissao: 'Data da comissão',
  icms: 'ICMS',
  valorIcms: 'Valor ICMS',
  tipoImportacao: 'Tipo de importação',
  ocultar: 'Ocultar',
  exibir: 'Exibir',
  'Cliente': 'Cliente',
  nomeArquivo: ' Nome arquivo',
  novoProcesso: 'Novo processo',
  referenciaPO: 'Referência (PO ou invoice)',
  expandirDiminuir: 'Expandir / Diminuir',
  despesasImportacaoDetalhamento: 'Despesas Importação Detalhamento',
  downloadPDF: 'Baixar PDF',
  recarregar: 'Recarregar',
  // Pré faturamento
  preFaturamento: 'Pré-faturamento',
  carregamentoProgramado: 'Carregamento programado',
  horario: 'Horário',
  liberacaoMapa: 'Liberação Mapa',
  liberacaoSiscarga: 'Liberação Siscarga',
  transportador: 'Transportador',
  taxaCambialDI: 'Taxa cambial D.I',
  beneficioFiscal: 'Benefício fiscal',
  descricaoItem: 'Descrição Item',
  despachante: 'Despachante',
  armazemDesembaraco: 'Armazém Desembaraço',
  recintoEntrada: 'Recinto de entrada',
  codigoInvoice: 'Código Invoice',
  quantidadeContainers: 'Quantidade de containers',
  quantidadeLIs: 'Quantidade de LI\'s',
  diasLivres: 'Dias livres',
  CE: 'C.E',
  desembaraco: 'Desembaraço',
  saldoConta: 'Saldo conta',
  custosAlocadosOutroProcesso: 'Custos alocados de outro processo',
  THC: 'THC',
  observacoesProcesso: 'Observações do processo',
  codigo: 'Código',
  emissao: 'Emissão',
  numeroDocumento: 'N° Doc',
  adiantamento: 'Adiantamento',
  descricaoPessoa: 'Descrição de pessoa',
  uf: 'UF',
  numAdicao: 'N° Adicao',
  numItem: 'N° Item',
  codigoExportacao: 'Código Exportação',
  contaProjeto: 'Conta de projeto',
  valorMoedaNacional: 'Valor moeda nacional',
  formaRateio: 'Forma rateio',
  encargo: 'Encargo',
  ONU: 'ONU',
  descricaoCliente: 'Descrição cliente',
  embalagem: 'Embalagem',
  nomePasta: 'Nome da pasta',
  informacoesProcesso: 'Informações do processo',
  financeiroPagar: 'Financeiro a pagar',
  comparativoProdutosDIs: 'Comparativo produto(s) D.I.',
  comparativoProdutoInvoice: 'Comparativo produto Invoice',
  custosEmissaoNF: 'Custos para emissão da NF',
  produtosProcesso: 'Produtos do processo',
  documentosGED: 'Documentos GED',
  comparativosProdutoDIs: 'Comparativo produto(s) D.I',
  mensagemRascunhos: 'Retome as informações de solicitações anteriores que não foram finalizadas.',
  editarSolicitacaoProcesso: 'Editar Solicitação de Processo',
  prazoPagamento: 'Prazo de pagamento',
  downloadExcel: 'Download tabela em Excel',
  substituta: 'Substituta',
  limparFiltros: 'Limpar filtros',
  valoresInvoice: 'Total dos produtos da invoice',
  PrevisaoArmazem: 'Previsão Armazém',
  DiasRestantesChegada: 'Dias restantes para chegada',
  dataMovimento: 'Data de movimento',
  segmentoProduto: 'Segmento do produto',
  valorProcesso: 'Valor total processo',
  dataChegouPorto: 'Carga já chegou ao porto de destino',
  previsaoDemandaDomestica: 'Previsão demanda doméstica',
  PrevisaoDemandaDomestica: 'Previsão demanda doméstica',
  demandaDomestica: 'Demanda doméstica',
  processosPendentes: 'Processos pendentes',
  bl: 'BL',
  enviosEmail: 'Envios no e-mail',
  esteProcessoPossui: 'Este processo possui',
  um: 'Um',
  acabouAberto: 'acabou de ser aberto',
  tooltipdataAbertura: 'Início formal do processo de importação com a Trading, começando os trâmites legais e administrativos.',
  tooltipdataEmbarque: 'Dia em que as mercadorias são efetivamente carregadas no meio de transporte para serem enviadas do país de origem para o país de destino.',
  tooltipnumeroRegistroDI: 'A Declaração de Importação registra detalhes como dados do fabricante, importador, classificação fiscal e valores de impostos. Trata-se de um pré-requisito para o despacho aduaneiro.',
  tooltipvistoriaMapa: 'O Ministério da Agricultura, Pecuária e Abastecimento é responsável pela fiscalização do trânsito internacional das embalagens, impedindo o ingresso de pragas.',
  tooltipeta: 'Data estimada da chegada do navio no porto.',
  tooltipetd: 'Data estimada da saída do navio no porto.',
  tooltiprecebimentoOriginais: 'São os documentos instrutivos do processo, exemplo: Invoice, packing list e BL.',
  tooltiptransbordo: 'As mercadorias terão que mudar de navio durante a viagem, pela rota já traçada.',
  tooltipsegundoTransbordo: 'As mercadorias terão que mudar de navio pela segunda vez durante a viagem, pela rota já traçada',
  tooltipdataLiberaçãoMapa: 'Data em que o Ministério da Agricultura, Pecuária e Abastecimento autoriza a liberação das mercadorias, mediante fiscalização documental ou física,',
  tooltipdataChegada: 'Momento em que as mercadorias importadas alcançam o porto de destino, marcando o início dos procedimentos aduaneiros e logísticos.',
  tooltipdesembaracoDI: 'Desembaraço aduaneiro da Declaração de Importação. Inclui a análise e aprovação pela alfândega dos documentos da importação, permitindo a liberação das mercadorias.',
  tooltipconhecimentoEmbarque: 'Também conhecido como Bill of Lading (B/L), serve como um recibo para as mercadorias embarcadas e como um documento de título da posse das mercadorias durante o transporte.',
  tooltipemissãoNotaEntrada: 'Geração de documento fiscal pela empresa importadora que é utilizado para formalizar a entrada dos produtos adquiridos no exterior.',
  tooltipdataCarregamento: 'Data que está previsto o carregamento do processo ou este já foi realizado.',
  tooltipexecucaoCarregamento: 'Data que o container foi retirado do Porto.',
  tooltipcarregamentoAgendado: 'Agendamento do momento em que as mercadorias serão carregadas para o veículo e retiradas do Porto. Não sei se tem na Trinity essa data.',
  tooltipfechamentoOperacional: 'Conclusão das operações logísticas e administrativas relacionadas à importação.',
  tooltipdataFaturamento: 'Emissão da Nota fiscal eletrônica, detalhando descrição das mercadorias, quantidades, preços, termos de pagamento, entre outros.',
  tooltipenvioFaturamento: 'Data que a NF-e foi enviada via sistema',
  ForgotPassword: 'Esqueci minha senha',
  consultarProcessos: 'Consultar processos',
  realizarCotacao: 'Realizar uma cotação',
  documentosGerais: 'Documentos gerais',
  fretes: 'Fretes',
  performance: 'Performance',
  analiseFrete: 'Análise de frete',
  acuraciaEstoque: 'Acurácia do estoque',
  eficaciaGeral: 'Eficácia geral',
  basicos: 'Básicos',
  portuariaVigentes: 'Portuária vigentes',
  tarefasComex: 'Tarefas do COMEX',
  interno: 'Interno',
  armazenamento: 'Armazenamento',
  gerais: 'Gerais',
  sugerirTrasnportadora: 'Sugerir transportadora',
  responsavelFrete: 'Responsável pelo Frete',
  agenciamentoInternacional: 'Agenciamento Internacional',
  LIs: 'LI\'s ',
  acuraciaArmazem: 'Eficácia Geral das Operações de Armazenagem (OOE)',
  operacional: 'operacional',
  deProcesso: 'de Processo',
  esteEMais: 'Este e mais',
  processosForamEncerrados: 'processos foram encerrados',
  esteProcessoEncerrado: 'Este processo foi encerrado',
};
